import { API_DASHBOARD_URL, API_TAEKWANG_URL } from '../constants/base-urls'
import type {
  FetchCalendarParams,
  IDashboardAnnouncement,
  IDashboardRecentlyApplied,
  IDashboardSchedule,
  IDashboardVacancies,
  IPaginationParam,
  IPaginationResponse,
} from '../types'
import { createAxiosInstance } from '../utils'

const axios = createAxiosInstance({
  baseURL: API_DASHBOARD_URL,
  withAuth: true,
})

const axiosTkg = createAxiosInstance({
  baseURL: API_TAEKWANG_URL,
  withAuth: true,
})

export const recentlyApplied = (params?: IPaginationParam) => {
  return axios.get<{ data: IPaginationResponse<IDashboardRecentlyApplied> }>(`/recently-applied`, { params }).then(({ data }) => data.data)
}

// export const recentlyPostedJobs = (params?: { departmentId?: string } & IPaginationParam) => {
//   return axios
//     .get<{ data: IPaginationResponse<IDashboardRecentlyPostedJob> }>(`/vacancies?status=recently_published`, { params })
//     .then(({ data }) => data.data)
// }

export const upcomingSchedule = (params?: { date?: string } & IPaginationParam) => {
  return axios.get<{ data: IPaginationResponse<IDashboardSchedule> }>(`/upcoming-schedule`, { params }).then(({ data }) => data.data)
}

export const fetchAnnouncements = (params?: { endDate?: string; startDate?: string } & IPaginationParam) => {
  return axios
    .get<{ data: IPaginationResponse<IDashboardAnnouncement> }>(`/announcements`, { params })
    .then((response) => response.data.data)
}

export const createAnnouncement = (payload: Record<string, any>) => {
  return axios.post(`/announcements/create`, payload).then((response) => response.data.data)
}

export const pinToggleAnnouncement = (oid: string) => {
  return axios.patch<{ data: IDashboardAnnouncement }>(`/announcements/pin/${oid}`).then((response) => response.data.data)
}

export const deleteAnnouncement = (oid: string) => {
  return axios.delete<{ data: IDashboardAnnouncement }>(`/announcements/delete/${oid}`).then((response) => response.data.data)
}

// export const fetchCalendar = (params?: { endDate?: string; startDate?: string } & IPaginationParam) => {
//   return axios.get<{ data: IPaginationResponse<IDashboardSchedule> }>(`/calendar`, { params }).then((response) => response.data.data)
// }

export const fetchCalendar = (params?: FetchCalendarParams) => {
  return axios.get<{ data: IPaginationResponse<IDashboardSchedule> }>(`/calendar`, { params }).then((response) => response.data.data)
}

export const fetchCalendarDetail = (oid: string, params: FetchCalendarParams) => {
  return axios.get<{ data: IDashboardSchedule }>(`/calendar/${oid}`, { params }).then((response) => response.data.data)
}

export const totalVacancies = (params?: IPaginationParam) => {
  return axiosTkg.get<{ data: IDashboardVacancies[] }>(`dashboard/vacancies`, { params }).then(({ data }) => data.data)
}
